module.exports = __webpack_public_path__ + "img/bagging_ilust_dg_woodpacking.d4df5cef.svg";